import { Tag } from "antd"
import PropTypes from "prop-types"
import { colors } from "themes/variables"

const selectedColor = {
  "Booking Request": colors.warning,
  Upcoming: colors.sportsmanBrand,
  Canceled: colors.error,
  Completed: colors.success,
  Paid: colors.success,
  Unpaid: colors.error,
  Partial: colors.yellow,
  Pending: colors.warning,
  "Partially Refunded": colors.sportsmanBrand,
  Refunded: colors.sportsmanBrand,
  Failed: colors.error,
  failed: colors.error,
  pending: colors.warning,
  processing: colors.sportsmanBrand,
  partial_completed: colors.warning,
  skipped_failed: colors.warning,
  completed: colors.success
}

const getStatusColor = (status) => {
  return selectedColor[status] || colors.textSecondary
}

const StatusTag = ({ status, statusMessage }) => {
  const color = getStatusColor(status)

  return (
    <Tag
      title={status}
      className={`px-s mr-0 py-xxs border-0`}
      style={{
        maxWidth: "fit-content",
        color: color,
        backgroundColor: color + "30"
      }}
    >
      {statusMessage ?? status}
    </Tag>
  )
}

StatusTag.propTypes = {
  status: PropTypes.string,
  statusMessage: PropTypes.string
}

export default StatusTag
